export const alertMessages = {
  withoutProperty: [
    <strong key="withoutProperty">
      Poxa, para seguir com a contratação é necessário um imóvel vinculado ao
      seu nome.
    </strong>,
    " Mas não se preocupe! Nós temos outras opções de empréstimo para você."
  ],
  notPropertyOwner: [
    <strong key="notPropertyOwner">
      Poxa, para seguir com a contratação é preciso ter um imóvel quitado.
    </strong>,
    " Mas não se preocupe! Nós temos outras opções de empréstimo para você."
  ],
  outdatedRegistration: [
    <strong key="outdatedRegistration">
      Poxa, para seguir com a contratação o imóvel deve estar atualizado junto
      ao cartório de imóveis.
    </strong>,
    " Mas não se preocupe! Nós temos outras opções de empréstimo para você."
  ]
}
